import React from 'react';

export default function Breadcrumb({ title }) {
  return (
    <div className="review-title-row">
      <div>
        <div className="review-kicker">Fee migration workspace</div>
        <h2 className="mb-1">{title}</h2>
        <div className="text-muted">Administrator review only · original PHP financial records remain unchanged</div>
      </div>
    </div>
  );
}
